export const mapZoomReducer = (state = 5, action) => {
    switch (action.type) {
        case 'mapZoom':
            return action.payload
        default:
            return state
    }
}
export default mapZoomReducer;